import dynamic from 'next/dynamic';
import { UserInfoFormProps } from './UserInfoForm.types';

export const UserInfoForm = dynamic<UserInfoFormProps>(() =>
  import('./UserInfoForm').then(module => module.UserInfoForm)
);
